<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<!--begin::BID Statistics and Event Calendar Row-->
<div class="row g-5 gx-xl-10 mb-5 mb-xl-10" >
  <!--begin::BID Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">BID Statistics</span>
          <span class="text-gray-500 mt-1 fw-semibold fs-6">Last One Week</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Stats Cards-->
        <div class="row g-3 mb-7">
          <!--begin::Total Bids-->
          <div class="col-4">
            <div class="card card-flush" style="background-color: #5DADE2;">
              <div class="card-body text-center py-5">
                <span class="fs-2hx fw-bold text-white d-block">{{bidStats.totalBids}}</span>
                <span class="text-white fw-semibold fs-6">Total Bids</span>
              </div>
            </div>
          </div>
          <!--end::Total Bids-->
          <!--begin::Avg Bids-->
          <div class="col-4">
            <div class="card card-flush" style="background-color: #F1948A;">
              <div class="card-body text-center py-5">
                <span class="fs-2hx fw-bold text-white d-block">{{bidStats.avgBids}}</span>
                <span class="text-white fw-semibold fs-6">Avg. Bids</span>
              </div>
            </div>
          </div>
          <!--end::Avg Bids-->
          <!--begin::Purchased-->
          <div class="col-4">
            <div class="card card-flush" style="background-color: #82E0AA;">
              <div class="card-body text-center py-5">
                <span class="fs-2hx fw-bold text-white d-block">{{bidStats.purchased}}</span>
                <span class="text-white fw-semibold fs-6">Purchased</span>
              </div>
            </div>
          </div>
          <!--end::Purchased-->
        </div>
        <!--end::Stats Cards-->
        <!--begin::Chart-->
        <div class="mb-3">
          <h4 class="fs-6 fw-bold text-gray-800 mb-3">Bids Statistics (Last One Week)</h4>
          <div id="kt_bid_statistics_chart" style="height: 300px;"></div>
        </div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::BID Statistics-->

  <!--begin::Event Calendar-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Event Calendar</span>
          <span class="text-gray-500 mt-1 fw-semibold fs-6">{{currentMonthYear}}</span>
        </h3>
        <div class="card-toolbar">
          <button class="btn btn-sm btn-icon btn-light me-1" (click)="previousMonth()">
            <i class="ki-duotone ki-left fs-2"></i>
          </button>
          <button class="btn btn-sm btn-icon btn-light" (click)="nextMonth()">
            <i class="ki-duotone ki-right fs-2"></i>
          </button>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Calendar-->
        <div class="calendar-wrapper">
          <!--begin::Calendar Header-->
          <div class="calendar-header d-flex mb-3">
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Su</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Mo</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Tu</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">We</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Th</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Fr</div>
            <div class="calendar-day-header text-center fw-bold text-gray-600 fs-7" style="flex: 1;">Sa</div>
          </div>
          <!--end::Calendar Header-->
          <!--begin::Calendar Body-->
          <div class="calendar-body">
            <div class="calendar-week d-flex mb-2" *ngFor="let week of calendarWeeks">
              <div class="calendar-day text-center py-2 px-1"
                   style="flex: 1; cursor: pointer; border-radius: 4px;"
                   *ngFor="let day of week"
                   [class.text-gray-400]="!day.isCurrentMonth"
                   [class.bg-primary]="day.isToday"
                   [class.text-white]="day.isToday"
                   [class.fw-bold]="day.isToday"
                   [class.text-gray-800]="day.isCurrentMonth && !day.isToday">
                <span class="fs-6">{{day.date}}</span>
              </div>
            </div>
          </div>
          <!--end::Calendar Body-->
        </div>
        <!--end::Calendar-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Event Calendar-->
</div>
<!--end::BID Statistics and Event Calendar Row-->


<!--begin::Vehicle Statistics and Top Countries Row-->
<div class="row g-5 gx-xl-10 mb-5 mb-xl-10" *ngIf="!isClient">
  <!--begin::Vehicle Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Vehicle Statistics</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body d-flex align-items-center justify-content-center">
        <!--begin::Chart-->
        <div id="kt_vehicle_statistics_chart" style="width: 100%; height: 300px;"></div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Vehicle Statistics-->

  <!--begin::Clients (Top 10 Countries)-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Clients (Top 10 Countries)</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Chart-->
        <div id="kt_top_countries_chart" style="height: 300px;"></div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Clients (Top 10 Countries)-->
</div>
<!--end::Vehicle Statistics and Top Countries Row-->

<!--begin::Enquiry Statistics and Client Statistics Row-->
<div class="row g-5 gx-xl-10 mb-5 mb-xl-10" *ngIf="!isClient">
  <!--begin::Enquiry Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Enquiry Statistics</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Chart-->
        <div id="kt_enquiry_statistics_chart" style="height: 300px;"></div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Enquiry Statistics-->

  <!--begin::Client Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Client Statistics</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body d-flex align-items-center justify-content-center">
        <!--begin::Stats Grid-->
        <div class="row g-3 w-100">
          <!--begin::Today's Client Register-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #3f4254;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.todayRegister}}</span>
                <span class="text-white fw-semibold fs-6">Today's Client Register</span>
              </div>
            </div>
          </div>
          <!--end::Today's Client Register-->
          <!--begin::Total Client-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #3f4254;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.totalClient}}</span>
                <span class="text-white fw-semibold fs-6">Total Client</span>
              </div>
            </div>
          </div>
          <!--end::Total Client-->
          <!--begin::Total Enquiry-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #50b5e9;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.totalEnquiry}}</span>
                <span class="text-white fw-semibold fs-6">Total Enquiry</span>
              </div>
            </div>
          </div>
          <!--end::Total Enquiry-->
          <!--begin::Avg. Enquiry-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #f8b4c8;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.avgEnquiry}}</span>
                <span class="text-white fw-semibold fs-6">Avg. Enquiry</span>
              </div>
            </div>
          </div>
          <!--end::Avg. Enquiry-->
          <!--begin::Permitted Clients-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #f9b851;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.permittedClients}}</span>
                <span class="text-white fw-semibold fs-6">Permitted Clients</span>
              </div>
            </div>
          </div>
          <!--end::Permitted Clients-->
          <!--begin::Blocked Clients-->
          <div class="col-6">
            <div class="card card-flush" style="background-color: #f1416c;">
              <div class="card-body text-center py-6">
                <span class="fs-2hx fw-bold text-white d-block">{{clientStats.blockedClients}}</span>
                <span class="text-white fw-semibold fs-6">Blocked Clients</span>
              </div>
            </div>
          </div>
          <!--end::Blocked Clients-->
        </div>
        <!--end::Stats Grid-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Client Statistics-->
</div>
<!--end::Enquiry Statistics and Client Statistics Row-->

<!--begin::Sales Statistics and Purchase Statistics Row-->
<div class="row g-5 gx-xl-10 mb-5 mb-xl-10" *ngIf="!isClient">
  <!--begin::Sales Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Sales Statistics</span>
          <span class="text-gray-500 mt-1 fw-semibold fs-6">Last 2 Months</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Stats Cards-->
        <div class="row g-3 mb-7">
          <!--begin::Total Units Sold-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #7239EA 0%, #9b6dff 100%);">
              <div class="card-body text-center py-5">
                <span class="fs-2hx fw-bold text-white d-block">{{salesStats.totalUnitsSold}}</span>
                <span class="text-white fw-semibold fs-6">Total Units Sold</span>
              </div>
            </div>
          </div>
          <!--end::Total Units Sold-->
          <!--begin::Total Sale Amount-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #50CD89 0%, #7ee8ae 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(salesStats.totalSaleAmountJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(salesStats.totalSaleAmountUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Total Sale Amount</span>
              </div>
            </div>
          </div>
          <!--end::Total Sale Amount-->
          <!--begin::Payment Received-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #F1416C 0%, #ff6b94 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(salesStats.paymentReceivedJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(salesStats.paymentReceivedUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Payment Received</span>
              </div>
            </div>
          </div>
          <!--end::Payment Received-->
          <!--begin::Client Outstanding-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #FFC700 0%, #ffd633 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(salesStats.clientOutstandingJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(salesStats.clientOutstandingUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Client Outstanding</span>
              </div>
            </div>
          </div>
          <!--end::Client Outstanding-->
        </div>
        <!--end::Stats Cards-->
        <!--begin::Chart-->
        <div class="mb-3">
          <h4 class="fs-6 fw-bold text-gray-800 mb-3">Sales Statistics (Jan - Feb)</h4>
          <div id="kt_sales_statistics_chart" style="height: 300px;"></div>
        </div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Sales Statistics-->

  <!--begin::Purchase Statistics-->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-xl-100">
      <!--begin::Header-->
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-800">Purchase Statistics</span>
          <span class="text-gray-500 mt-1 fw-semibold fs-6">Last 2 Months</span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <!--begin::Stats Cards-->
        <div class="row g-3 mb-7">
          <!--begin::Total Units Purchased-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #009EF7 0%, #33b3ff 100%);">
              <div class="card-body text-center py-5">
                <span class="fs-2hx fw-bold text-white d-block">{{purchaseStats.totalUnitsPurchased}}</span>
                <span class="text-white fw-semibold fs-6">Total Units Purchased</span>
              </div>
            </div>
          </div>
          <!--end::Total Units Purchased-->
          <!--begin::Total Purchase Value-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #181C32 0%, #3f4254 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(purchaseStats.totalPurchaseValueJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(purchaseStats.totalPurchaseValueUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Total Purchase Value</span>
              </div>
            </div>
          </div>
          <!--end::Total Purchase Value-->
          <!--begin::Payment Paid-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #F1416C 0%, #ff6b94 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(purchaseStats.paymentPaidJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(purchaseStats.paymentPaidUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Payment Paid</span>
              </div>
            </div>
          </div>
          <!--end::Payment Paid-->
          <!--begin::Vendor Outstanding-->
          <div class="col-6">
            <div class="card card-flush" style="background: linear-gradient(135deg, #7239EA 0%, #9b6dff 100%);">
              <div class="card-body text-center py-3">
                <div class="mb-2">
                  <span class="fs-3 fw-bold text-white d-block">{{formatCurrencyJPY(purchaseStats.vendorOutstandingJPY)}}</span>
                  <span class="fs-6 fw-bold text-white d-block">{{formatCurrencyUSD(purchaseStats.vendorOutstandingUSD)}}</span>
                </div>
                <span class="text-white fw-semibold fs-6">Vendor Outstanding</span>
              </div>
            </div>
          </div>
          <!--end::Vendor Outstanding-->
        </div>
        <!--end::Stats Cards-->
        <!--begin::Chart-->
        <div class="mb-3">
          <h4 class="fs-6 fw-bold text-gray-800 mb-3">Purchase Statistics (Jan - Feb)</h4>
          <div id="kt_purchase_statistics_chart" style="height: 300px;"></div>
        </div>
        <!--end::Chart-->
      </div>
      <!--end::Body-->
    </div>
  </div>
  <!--end::Purchase Statistics-->
</div>
<!--end::Sales Statistics and Purchase Statistics Row-->



<app-add-event-modal *ngIf="!isClient"></app-add-event-modal>
<app-view-event-modal *ngIf="!isClient"></app-view-event-modal>
